import React from 'react';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

export default function CustomSeparator(props) {

  const {breadCrumbsList} = props;

  function handleClick(item, breadCrumbsList) {
    if (item.url) {
      breadCrumbsList.pop()
      props.setBreadCrumbsList(breadCrumbsList)
      props.history.push(item.url);

    }
  }

  return (
    <div className={'sticky-header'}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small"/>} aria-label="breadcrumb"
      >
        {breadCrumbsList.map((item, index) => {
          if (index < breadCrumbsList.length - 1) {
            return (
              <Link
                key={`crumb${index}`}
                color="inherit"
                // href="/"
                onClick={(e) => handleClick(item, breadCrumbsList)}
                className='text-capitalize text-doc-none mouse-pointer'>
                {item.text}
              </Link>
            )
          } else return (<Typography key={`crumb${index}`} className='text-capitalize primary-blue-color'
                                     >{breadCrumbsList[breadCrumbsList.length - 1].text}</Typography>)
        })}

      </Breadcrumbs>
    </div>
  );
}
